<template>
  <v-card flat class="pa-5">
    <v-row>
      <v-col cols="6">
         <h1 class="headline font-weight-medium">MIS OFICIOS</h1>
        <!-- <h1 class="headline font-weight-medium">Oficios {{ $route.params.tipo }}</h1> -->
        <v-btn v-if="sinFinalizar>0" depressed small color="red lighten-4">OFICIOS SIN TERMINAR {{sinFinalizar}}</v-btn>
        <!-- <v-btn v-if="sinFinalizar>0" depressed small color="red">TERMINAR OFICIOS</v-btn> -->
      </v-col>
      <v-col>
        <v-text-field v-model="search" @keydown.enter="onSearchSubmit()" append-icon="mdi-magnify" label="Buscar"
          single-line clearable dense
          :hint="$route.params.tipo === 'Entrantes' ? 'Buscar por número, para o asunto' : 'Buscar por número, generó, para o asunto'">
        </v-text-field>
        <v-row no-gutters justify-md="space-between" justify="center">
          <v-btn depressed small color="teal lighten-4" :disabled="$route.query.filter == '0'"
            @click="toggleFilter(0)">Ver todo</v-btn>
          <v-btn depressed small color="orange lighten-4" :disabled="$route.query.filter == '1'"
            @click="toggleFilter(1)">Documentos con errores</v-btn>
          <v-btn depressed small color="red lighten-4" :disabled="$route.query.filter == '2'"
            @click="toggleFilter(2)">Documentos Faltantes</v-btn>
        </v-row>
      </v-col>
    </v-row>
    <v-data-table v-if="$route.params.tipo === 'Entrantes'" :headers="headersEntrantes" :items="oficios"
      :loading="loading" loading-text="Cargando Oficios..." no-data-text="No hay oficios para mostrar."
      :items-per-page="10" class="elevation-1 mb-5 mt-10" hide-default-footer>
      <template v-slot:[`item.numero`]="{ item }">
        <router-link
          :to="{ name: 'Consultar oficio', params: item.relacionado.id ? { tipo: item.relacionado.tipo, id: item.relacionado.id } : { tipo: 'entrante', id: item._id } }"><span
            v-html="item.numero"></span></router-link>
      </template>
      <template v-slot:[`item.para`]="{ item }">
        <span v-if="item.destinatario.usuario">{{ item.destinatario.usuario.titulo }} <span
            v-html="item.destinatario.usuario.nombreCompleto"></span></span>
      </template>
      <template v-slot:[`item.documento`]="{ item }">
        <v-icon :color="fileColor(item.files)">mdi-file-{{ fileChecker(item.files) }}</v-icon>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        {{ item.status }} 
       <v-tooltip right v-if="item.status!='Terminado'&& !loadingFinalizar">
        <template v-slot:activator="{ on }">
          <v-icon  v-on="on" @click="terminar(item._id)" small color="orange">mdi-pencil</v-icon>
        </template>
        <span>Terminar oficio</span>
      </v-tooltip>
      <v-icon small v-if="loadingFinalizar" color="blue">mdi-loading</v-icon>
      </template>
      <template v-slot:[`item.fecha`]="{ item }">
        {{ showDate(item.fecha) }}
      </template>
      <template v-slot:[`item.recepcion`]="{ item }">
        {{ showDate(item.recepcion) }}
      </template>
      <template v-slot:[`item.asunto`]="{ item }">
        <span v-html="item.asunto"></span>
      </template>
    </v-data-table>
    <v-data-table v-else :headers="headersGenerados" :items="oficios" :loading="loading"
      loading-text="Cargando Oficios..." no-data-text="No hay oficios para mostrar." :items-per-page="10"
      class="elevation-1 mb-5 mt-10" hide-default-footer>
      <template v-slot:[`item.numeroCompleto`]="{ item }">
        <router-link
          :to="{ name: 'Consultar oficio', params: item.relacionado.id ? { tipo: item.relacionado.tipo, id: item.relacionado.id } : { tipo: 'generado', id: item._id } }"><span
            v-html="item.numeroCompleto"></span></router-link>
      </template>
      <template v-slot:[`item.asunto`]="{ item }">
        <span v-html="item.asunto"></span>
      </template>
      <template v-slot:[`item.documento`]="{ item }">
        <v-icon :color="fileColor(item.files)">mdi-file-{{ fileChecker(item.files) }}</v-icon>
      </template>
      <template v-slot:[`item.para`]="{ item }">
        <span v-html="item.destinatario.responsable"></span>
      </template>
      <template v-slot:[`item.genero`]="{ item }">
        <span v-if="item.emisor.usuario">{{ item.emisor.usuario.titulo }} <span
            v-html="item.emisor.usuario.nombreCompleto"></span></span>
      </template>
      <template v-slot:[`item.fecha`]="{ item }">
        {{ showDate(item.fecha) }}
      </template>
      <template v-slot:[`item.fechaRecibido`]="{ item }">
        {{ showDate(item.fechaRecibido) }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        {{ item.status }} 
       <v-tooltip right v-if="item.status!='Terminado'&& !loadingFinalizar">
        <template v-slot:activator="{ on }">
          <v-icon  v-on="on" @click="terminar(item._id)" small color="orange">mdi-pencil</v-icon>
        </template>
        <span>Terminar oficio</span>
      </v-tooltip>
      <v-icon small v-if="loadingFinalizar" color="blue">mdi-loading</v-icon>
      </template>
    </v-data-table>
    <section class="d-flex justify-center align-center flex-column">
      <div class="d-flex">
        <v-pagination v-model="page" @input="onPageChange" :length="totalPages || 1" :total-visible="6"
          class="mr-2" color="blue-grey"></v-pagination>
        <v-select style="max-width: 175px;" @input="onSelectChange" :value="`Página ${page}`"
          :menu-props="{ top: true, offsetY: true }" :items="Array.from({ length: totalPages || 1 }, (_, i) => `Página ${i + 1}`)"
          hide-details outlined dense></v-select>
      </div>
      <span class="grey--text text-center">Mostrando {{ (page != totalPages && page < totalPages) ? page * 10 :
        totalOficios }} de {{ totalOficios }} oficios. </span>
    </section>
  </v-card>
</template>

<script>
import { cargarOficiosEntrantesPersonalesService, cargarOficiosGeneradosPersonalesService, terminarOficio } from '../components/oficiosPersonales/oficiosPersonales.service';
import { DateTime } from 'luxon';
export default {
  name: 'OficiosVistaMisOficios',

  data() {
    return {
      search: '',
      headersGenerados: [
        { text: 'Documento', value: 'documento', sortable: false },
        { text: 'Número', value: 'numeroCompleto', sortable: false },
        { text: 'Estatus', value: 'status', sortable: false },
        { text: 'Fecha', value: 'fecha', sortable: false },
        { text: 'Recepción', value: 'fechaRecibido', sortable: false },
        { text: 'Generó', value: 'genero', sortable: false },
        { text: 'Para', value: 'para', sortable: false },
        { text: 'Asunto', value: 'asunto', sortable: false },
      ],
      headersEntrantes: [
        { text: 'Documento', value: 'documento', sortable: false },
        { text: 'Número', value: 'numero', sortable: false },
        { text: 'Estatus', value: 'status', sortable: false },
        { text: 'Tipo', value: 'tipoDocumento', sortable: false },
        { text: 'Fecha', value: 'fecha', sortable: false },
        { text: 'Recepción', value: 'recepcion', sortable: false },
        { text: 'Para', value: 'para', sortable: false },
        { text: 'Asunto', value: 'asunto', sortable: false },
      ],
      oficios: [],
      page: 1,
      totalPages: 1,
      totalOficios: 1,
      loading: false,
      filter: 0,
      sinFinalizar:0,
      loadingFinalizar:false
    };
  },

  async mounted() {
    try {
      await this.fetchOficios();
    } catch (error) {
      this.$notify({
        title: 'Error',
        message: error.message,
        type: 'error',
      });
    }
  },

  watch: {
    async $route(to, from) {
      try {
        await this.fetchOficios();
      } catch (error) {
        this.$notify({
          title: 'Error',
          message: error.message,
          type: 'error',
        });
      }
    },
  },

  methods: {
    verifyQuery(query) {

      if (!query) return false;

      if (!Object.keys(query).includes('page') || !Object.keys(query).includes('search') || !Object.keys(query).includes('filter')) return false;

      if (isNaN(parseInt(query.page))) return false;

      if (isNaN(parseInt(query.filter)) || parseInt(query.filter) < 0 || parseInt(query.filter) > 3) return false;

      if (this.$route.params.tipo !== 'Entrantes' && this.$route.params.tipo !== 'Generados') return false;

      return true;

    },
    toggleFilter(filter) {
      this.$router.push({ query: { page: 1, search: this.search, filter } });
    },
    onPageChange() {
      this.$router.push({ query: { page: this.page, search: this.search, filter: this.filter } });
    },
    onSelectChange(page) {
      this.$router.push({ query: { page: page.split(' ')[1], search: this.search, filter: this.filter } });
    },
    onSearchSubmit() {
      this.$router.push({ query: { page: 1, search: this.search, filter: this.filter } });
    },
    async fetchOficios() {
      try {
        this.loading = true;
        this.oficios = [];
        if (!this.verifyQuery(this.$route.query)) this.$router.replace({ query: { page: 1, search: '', filter: 0 }, params: { tipo: 'Entrantes' } });
        this.page = parseInt(this.$route.query.page);
        this.filter = parseInt(this.$route.query.filter);
        this.search = this.$route.query.search;
        const repoToUse = this.$route.params.tipo === 'Entrantes' ? cargarOficiosEntrantesPersonalesService : cargarOficiosGeneradosPersonalesService;
        const serverResponse = await repoToUse(this.page, this.search, this.filter);
        if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
        if (serverResponse.paginas + 1 < this.page) this.$router.replace({ query: { page: 1, search: this.search } });
        this.oficios = serverResponse.oficios;
        // console.log(serverResponse);
        this.sinFinalizar=serverResponse.sinFinalizar;
        this.totalPages = serverResponse.paginas;
        this.totalOficios = serverResponse.totalOficios;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        throw error;
      }
    },
    showDate(date) {
      if (!date) return 'No capturada.';
      let dateObj = DateTime.fromSQL(date);
      if (!dateObj.isValid) dateObj = DateTime.fromSQL(date.split(' ')[0]);
      if (!dateObj.isValid) return 'No capturada.';
      return dateObj.toFormat('dd/MM/yyyy');
    },
    fileChecker(files) {
      if (!files.length) return 'cancel';
      for (const file of files) {
        if (file.type !== 'application/pdf') return 'alert';
      }
      return 'check';
    },
    fileColor(files) {
      if (!files.length) return 'error';
      for (const file of files) {
        if (file.type !== 'application/pdf') return 'warning';
      }
      return 'success';
    },
    async terminar(id){
       try {
        this.loadingFinalizar = true;
        const tipo = this.$route.params.tipo == 'Generados' ? 'generado' : 'entrante'
        const serverResponse = await terminarOficio(tipo, id);
        if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
        this.sinFinalizar=this.sinFinalizar-1;
        let index = this.oficios.findIndex(x=>x._id==id)
        this.oficios[index].status=serverResponse.oficio.status;
        this.loadingFinalizar = false;
      } catch (error) {
        this.loading = false;
        throw error;
      }
    }
  },
};
</script>